import { Link, useParams } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { modules } from "../data/modules";
import { isComplete }
    from "../utils/progress";
import { useEffect } from "react";
import { Helmet } from "react-helmet-async";

export default function Module() {
    const { moduleId } = useParams();
    const { user } = useAuth();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [moduleId]);
    const module = modules.find(
        (module) => module.id === moduleId
    )
    const locked = !!module?.membersOnly && !user;

    if (!module) {
        return <h2>Module not found</h2>;
    }

    return (
        <>
            <Helmet>
                <title>{module.seoTitle}</title>
                <meta
                    name="description"
                    content={module.seoDescription}
                />
            </Helmet>

            <div
                style={{
                    maxWidth: "1000px",
                    margin: "0 auto",
                    padding: "2rem"
                }}
            >
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "1rem",
                        flexWrap: "wrap",
                        gap: "0.5rem"
                    }}
                >
                    <Link to="/" className="safe-top-link">
    ← Home
</Link>

                    {user ? (
                        <div
                            style={{
                                display: "flex",
                                gap: "1rem",
                                flexWrap: "wrap"
                            }}
                        >
                            <Link to="/progress">
                                My Progress
                            </Link>

                            <Link to="/journal">
                                Learning Journal
                            </Link>

                            <Link to="/account">
                                My Account
                            </Link>
                        </div>
                    ) : (
                        <Link to="/login">
                            Save Progress
                        </Link>
                    )}
                </div>
                <div
                    style={{
                        textAlign: "center",
                        margin: "1rem 0"
                    }}
                >
                    <img
                        src="/logo.png"
                        alt="Figure It Out"
                        style={{
                            width: "140px",
                            maxWidth: "60%",
                            height: "auto"
                        }}
                    />
                </div>

                <h1>{module.title}</h1>

                <p>{module.description}</p>
                {locked && (
                    <div
                        style={{
                            background: "#fff8e1",
                            border: "1px solid #f0c36d",
                            borderRadius: "10px",
                            padding: "1.5rem",
                            marginBottom: "2rem",
                            textAlign: "center"
                        }}
                    >
                        <h3>Members Only</h3>

                        <p>
                            Create a free account to unlock these activities, save your
                            progress and use your Learning Journal.
                        </p>

                        <div
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                gap: "1rem",
                                marginTop: "1rem"
                            }}
                        >
                            <Link to="/signup">Create Free Account</Link>
                            <Link to="/login">Log In</Link>
                        </div>
                    </div>
                )}
                <h2>Activities</h2>

                {module.activities.map((activity) => (
                    <div
                        key={activity.id}
                        style={{
                            border: "1px solid #ccc",
                            padding: "1rem",
                            marginBottom: "1rem",
                            borderRadius: "8px"
                        }}
                    >
                        <h3>
                            {activity.title}
                            {isComplete(activity.id)
                                ? <span
                                    style={{
                                        color: "green",
                                        fontWeight: "bold"
                                    }}
                                >
                                    ✓
                                </span>
                                : ""}

                        </h3>

                        {activity.premium && (
                            <p>⭐ Premium</p>
                        )}

                        {locked ? (
                            <button
                                disabled
                                style={{
                                    padding: "0.5rem 1rem",
                                    cursor: "not-allowed"
                                }}
                            >
                                🔒 Members Only
                            </button>
                        ) : (
                            <Link to={`/activity/${activity.id}`}>
                                Open Activity
                            </Link>
                        )}
                    </div>
                ))}

                <section
                    style={{
                        marginTop: "3rem",
                        paddingTop: "2rem",
                        borderTop: "1px solid #ccc",
                        textAlign: "center"
                    }}
                >
                    <nav
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            gap: "1rem",
                            flexWrap: "wrap"
                        }}
                    >
                        <Link to="/about">About</Link>
                        <Link to="/contact">Contact</Link>
                        <Link to="/privacy">Privacy</Link>
                        <Link to="/terms">Terms</Link>
                        <Link to="/credits">Credits</Link>
                    </nav>

                    <a
                        href="https://www.facebook.com/figureitout.au"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Follow Figure It Out on Facebook"
                        style={{
                            display: "inline-block",
                            marginTop: "1.5rem"
                        }}
                    >
                        <img
                            src="/facebook.png"
                            alt="Facebook"
                            style={{
                                width: "34px",
                                height: "34px"
                            }}
                        />
                    </a>

                    <p
                        style={{
                            marginTop: "1rem",
                            fontSize: "0.85rem",
                            color: "#666"
                        }}
                    >
                        © 2026 Figure It Out
                    </p>
                </section>
            </div>
        </>
    );
}